export default __webpack_public_path__ + "static/media/016-sword.4c4da2bc.png";